import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import BaseMenu from '../BaseMenu.js';

const Menu = /*#__PURE__*/React__default.forwardRef(function Menu(_ref, ref) {
  let {
    selectable,
    defaultLabel,
    defaultValue,
    selectedValue: externalSelectedValue,
    onSelectedValueChange,
    unstable_isMultiSelect,
    // Throw away since it's only part of SelectMenu
    isMultiSelect,
    // Throw away since it's only part of SelectMenu
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(BaseMenu, _extends({
    ref: ref,
    menuType: Menu
  }, rest));
});

export { Menu as default };
